export interface AngularJsHttpResponse {
  data: any;
  status: number;
  statusText?: string;
}

export function isAngularJsHttpResponse(error: any): error is AngularJsHttpResponse {
  return error && 'data' in error;
}
